import React, {useState, useCallback} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { CREATE_CONTACT } from './queries';
import { ButtonContainer } from './elements';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewContact = props => {
  const {setShowModal, refetch, sellerId, setUpdatedContactDetails} = props;
  const [submitting, setSubmitting] = useState();
  const [createContact] = useMutation(CREATE_CONTACT, {
    onCompleted: (response) => {
      setUpdatedContactDetails(response.createContact.contact, true)
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    createContact({ variables: input });
  });

  const { control, handleSubmit, register, formState: { errors } } = useForm({
    defaultValues: {
      sellerId: sellerId,
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      primary: false
    }
  });

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          <Input.Text
            label="First Name:"
            name="firstName"
            control={control}
            errors={errors}
            {...register("firstName", {
              required: "Required",
            })}
          />
          <Input.Text
            label="Last Name:"
            name="lastName"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Title:"
            name="title"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Phone Number:"
            name="phoneNumber"
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Primary Contact?:"
            name="primary"
            control={control}
            errors={errors}
          />
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Contact" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewContact;
